export const FILTER_ENTITY_TYPE_API = 'api';
export const FILTER_ENTITY_TYPE_API_KEY = 'apiKey';
export const FILTER_ENTITY_TYPE_APP = 'app';
export const FILTER_ENTITY_TYPE_ORG = 'org';
export const FILTER_ENTITY_TYPE_API_PER_ORG = 'apiperorg';
export const FILTER_ENTITY_TYPE_GATEWAY = 'gatewayServer';
export const FILTER_ENTITY_TYPE_RESPONSE = 'respCode';
export const FILTER_ENTITY_TYPE_URI = 'uri';

export const FILTER_TYPE_RANK = 'FILTER_TYPE_RANK';
export const FILTER_TYPE_NAME = 'FILTER_TYPE_NAME';
export const FILTER_TYPE_CODE = 'FILTER_TYPE_CODE';
export const FILTER_TYPE_URI = 'FILTER_TYPE_URI';
export const FILTER_TYPE_RANGE = 'FILTER_TYPE_RANGE';
export const FILTER_TYPE_RANK_API_PER_ORG = 'FILTER_TYPE_RANK_API_PER_ORG';
export const FILTER_TYPE_NAME_API_PER_ORG = 'FILTER_TYPE_NAME_API_PER_ORG';
export const API_PER_ORG_RANK_FILTER_TYPE_OVER_ALL_RANK = 'API_PER_ORG_RANK_FILTER_TYPE_OVER_ALL_RANK';
export const API_PER_ORG_RANK_FILTER_TYPE_RANK_FOR_API = 'API_PER_ORG_RANK_FILTER_TYPE_RANK_FOR_API';
export const API_PER_ORG_RANK_FILTER_TYPE_RANK_FOR_ORG = 'API_PER_ORG_RANK_FILTER_TYPE_RANK_FOR_ORG';

export const UPDATE_SELECTED_APPS = 'UPDATE_SELECTED_APPS';
export const FETCH_SELECTED_APPS = 'FETCH_SELECTED_APPS';

export const USER_FILTER_STATE = 'uf';
export const USER_FILTER_STATE_PATH = '/admin/app/analytics-dashboard';
export const USER_FILTER_STATE_PATH_DEV = '/analytics-dashboard';
export const USER_FILTER_STATE_DURATION = 365; // days
export const SET_USER_FILTER_STATE = 'SET_USER_FILTER_STATE';
export const USER_FILTER_METRICS = 'm';
export const USER_FILTER_DATE = 'd';

export const FILTER_ENTITY_TYPE_API_ID = 'apiId';
export const FILTER_ENTITY_TYPE_APP_ID = 'appId';
export const FILTER_ENTITY_TYPE_ORG_ID = 'orgId';
export const FILTER_ENTITY_TYPE_GATEWAY_ID = 'gatewayServerId';
